import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-aboutus-custom-brand',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
    templateUrl: './aboutus-custom-brand.html',
  styleUrl: './aboutus-custom-brand.scss',
})
export class AboutusCustomBrand {

}
